import { idfDepartments } from 'src/data/departements'

import { Offer } from '../rest/types/Offer'

export const averageScore = (ratings: Array<number>) => {
  return ratings.length
    ? Math.round(
        (ratings.reduce((x: number, y: number) => x + y) / ratings.length) * 10
      ) / 10
    : 0
}

export const numberOfDays = (offerDate: string) => {
  const replaceDashToSlash = offerDate.replace(/-/g, '/')

  const endOfOffer = new Date(replaceDashToSlash)
  const today = new Date()

  const difference = endOfOffer.getTime() - today.getTime()

  const days = Math.ceil(difference / (1000 * 3600 * 24))

  return days.toString()
}

export const sortByHigherPrice = (a: Offer, b: Offer) => {
  const priceA = a.card?.[0]?.price ? parseInt(a.card?.[0]?.price) : null
  const priceB = b.card?.[0]?.price ? parseInt(b.card?.[0]?.price) : null

  if (!priceA || !priceB) return 0
  if (priceA > priceB) return -1
  if (priceA < priceB) return 1

  return 0
}

export const sortByLowerPrice = (a: Offer, b: Offer) => {
  const priceA = a.card?.[0]?.price ? parseInt(a.card?.[0]?.price) : null
  const priceB = b.card?.[0]?.price ? parseInt(b.card?.[0]?.price) : null

  if (!priceA || !priceB) return 0
  if (priceA > priceB) return 1
  if (priceA < priceB) return -1

  return 0
}

export const sortByFeedbacks = (a: Offer, b: Offer) => {
  const averageA = a.feedbacks
    ? averageScore(a.feedbacks.map((f: any) => parseInt(f?.rating)))
    : null

  const averageB = b.feedbacks
    ? averageScore(b.feedbacks.map((f: any) => parseInt(f?.rating)))
    : null

  if (!averageA || !averageB) return 0
  if (averageA > averageB) return 1
  if (averageA < averageB) return -1

  return 0
}

export const getSortedFilteredDepartments = (
  departments: Record<string, number> | null | undefined
): [string, number][] => {
  if (!departments || typeof departments !== 'object') return []

  // Format attendu: "75, Paris, Île-de-France"
  // (on accepte 2A/2B aussi, au cas où)
  const DEPT_KEY_RE = /^(?<dept>\d{2}|2A|2B)\s*,\s*[^,]+\s*,\s*[^,]+/i

  const deptSortKey = (dept: string) => {
    if (dept.toUpperCase() === '2A') return 20.1
    if (dept.toUpperCase() === '2B') return 20.2
    const n = Number(dept)
    return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY
  }

  // Map par département pour dédoublonner
  const byDept = new Map<string, { key: string; value: number }>()

  for (const [key, value] of Object.entries(departments)) {
    const match = key.match(DEPT_KEY_RE)
    if (!match?.groups?.dept) continue

    const dept = match.groups.dept.trim()
    if (!idfDepartments.includes(dept)) continue

    const prev = byDept.get(dept)
    if (!prev) {
      byDept.set(dept, { key, value })
    } else {
      // On additionne les valeurs si doublon de département
      const nextValue = prev.value + value
      // On garde la clé la plus "complète" (souvent la plus longue)
      const nextKey = key.length > prev.key.length ? key : prev.key
      byDept.set(dept, { key: nextKey, value: nextValue })
    }
  }

  return Array.from(byDept.entries())
    .sort(([d1], [d2]) => deptSortKey(d1) - deptSortKey(d2))
    .map(([, v]) => [v.key, v.value])
}

export const transformFilters = ({
  brand,
  categories,
  groupPurchase,
}: {
  brand?: Array<string | number>
  categories?: Array<string | number>
  groupPurchase?: Array<string>
}) => {
  return {
    brand: brand?.map((v) => (typeof v === 'string' ? parseInt(v) : v)) || [],
    categories:
      categories?.map((v) => (typeof v === 'string' ? parseInt(v) : v)) || [],
    groupPurchase: groupPurchase || [],
  }
}
